const API_CONFIG = {
    development: {
      baseURL: 'http://localhost:5001/api'
    },
    production: {
      baseURL: 'https://divya-enterprise-accounts-backend.vercel.app/api'
    }
  };
  
  export const API_BASE_URL = API_CONFIG[process.env.NODE_ENV || 'development'].baseURL;
  
  // Axios instance with base configuration
  import axios from 'axios';
  
  const api = axios.create({
    baseURL: API_BASE_URL,
    timeout: 10000,
    headers: {
      'Content-Type': 'application/json'
    }
  });
  
  // Request interceptor to add auth token
  api.interceptors.request.use(
    (config) => {
      const token = localStorage.getItem('divya_token');
      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      }
      return config;
    },
    (error) => {
      return Promise.reject(error);
    }
  );
  
  // Response interceptor for error handling
  api.interceptors.response.use(
    (response) => response,
    (error) => {
      if (error.response?.status === 401) {
        localStorage.removeItem('divya_token');
        localStorage.removeItem('divya_user');
        window.location.href = '/login';
      }
      return Promise.reject(error);
    }
  );
  // config/api.js - Add these functions
export const importExcelFile = async (sessionId, formData) => {
    const response = await api.post(`/sessions/${sessionId}/import-excel`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
    return response.data;
  };
  
  export const exportPDF = async (sessionId, filters = {}) => {
    const params = new URLSearchParams(filters).toString();
    const response = await api.get(`/transactions/export-pdf/${sessionId}?${params}`, {
      responseType: 'blob'
    });
    
    // Create download link
    const blob = new Blob([response.data], { type: 'application/pdf' });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = `account_statement_${Date.now()}.pdf`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
    
    return true;
  };
  export default api;